<template>
  <main>
    <Transition name="fade">
      <Loader v-if="!$page || !$beet.isReady" />
    </Transition>
    <template v-if="$page && $beet.isReady">
      <Banner v-if="$page.header" :content="$page.header" class="--home" />
      <AboutSection :content="aboutSection" />
      <CTASection :content="roomsSection" />
      <RestaurantsSection :content="restaurantsSection" />
    </template>
  </main>
</template>
<script>
import AboutSection from '@/components/sections/AboutSection.vue'
import Banner from '@/components/sections/Banner.vue'
import CTASection from '@/components/sections/CTASection.vue'
import RestaurantsSection from '@/components/sections/RestaurantsSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  mixins: [PageMetaMixin],
  name: 'Home',
  beetPage: 'home',
  components: { AboutSection, Banner, CTASection, Loader, RestaurantsSection },
  computed: {
    aboutSection() {
      return {
        contact: {
          address: this.$beet.options.contact.address,
          city: this.$beet.options.contact.city,
          link: this.$beet.options.contact.map_link,
          postal_code: this.$beet.options.contact.postal_code,
          state: this.$beet.options.contact.state,
        },
        hotel_label: this.$page.about.hotel_label,
        image: this.$page.about.image,
        route: { name: 'hotel' },
        titleBlock: {
          description: this.$page.about.subtitle,
          subtitle: this.$page.about.title,
          title: this.$page.about.label,
        },
      }
    },
    roomsSection() {
      return {
        button: this.$page.rooms.explore_button,
        image: this.$page.rooms.image,
        route: { name: 'rooms' },
        titleBlock: {
          description: this.$page.rooms.subtitle,
          subtitle: this.$page.rooms.title,
          title: this.$page.rooms.label,
        },
      }
    },
    restaurantsSection() {
      return {
        restaurants: Object.values(this.$beet.options.restaurants),
        titleBlock: {
          description: this.$page.restaurants.subtitle,
          subtitle: this.$page.restaurants.title,
          title: this.$page.restaurants.label,
        },
      }
    },
  },
}
</script>
